import { render, staticRenderFns } from "./WithdrawDeposit.vue?vue&type=template&id=1009a3ec"
import script from "./WithdrawDeposit.vue?vue&type=script&lang=js"
export * from "./WithdrawDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports